import BaseModel from "@/core/components/input-widget/BaseModel";

export default class BulkEditDownloadModel extends BaseModel {
  receipt_uuids = [];
  auction_uuids = [];

  constructor() {
    super();
    this.rules = {};
    this.attributeLabels = {
      receipt_uuids: 'Select Receipts',
      auction_uuids: 'Select Sales'
    };
  }
}
